import { match } from '@/utils/pattern-match-util'

export type AvailableBookkeepingSoftwareType =
  (typeof availableBookkeepingSoftwareTypes)[number]

/**
 * The software a client can pick from once they select the `Other` platform.
 */
export const availableBookkeepingSoftwareTypes = [
  'Freshbooks',
  'Puzzle',
  'Sage',
  'Wave',
  'Other',
] as const

export function formatAvailableBookkeepingSoftware(
  type: AvailableBookkeepingSoftwareType,
) {
  return match(type, {
    Freshbooks: 'FreshBooks',
    Puzzle: 'Puzzle',
    Sage: 'Sage',
    Wave: 'Wave',
    Other: 'Other',
  })
}

/**
 * Gets the token the API uses to identify the software.
 */
export function getAvailableBookkeepingSoftwareToken(
  type: AvailableBookkeepingSoftwareType,
) {
  return match(type, {
    Freshbooks: 'FRESHBOOKS',
    Puzzle: 'PUZZLE',
    Sage: 'SAGE',
    Wave: 'WAVE',
    Other: 'OTHER',
  })
}
